import React, { useState } from 'react';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import { ExportCard } from '../ExportCard';
import { exportCollaborators } from '../../services';

interface CollaboratorsExportCardProps {
    onError: (message: string | null) => void;
}

/** Exportação do cadastro simplificado de colaboradores. */
export const CollaboratorsExportCard: React.FC<CollaboratorsExportCardProps> = ({ onError }) => {
    const [isExporting, setIsExporting] = useState(false);

    const handleExport = async () => {
        setIsExporting(true);
        onError(null);

        try {
            await exportCollaborators();
        } catch (error) {
            console.error('Erro ao exportar colaboradores:', error);
            onError('Falha ao gerar a exportação de colaboradores. Tente novamente.');
        } finally {
            setIsExporting(false);
        }
    };

    return (
        <ExportCard
            title="Colaboradores"
            description="Exportação contendo cadastro simplificado para input de alocações."
            icon={DocumentTextIcon}
            isExporting={isExporting}
            onExport={handleExport}
        />
    );
};

export default CollaboratorsExportCard;
